export const API_ENDPOINT: string = import.meta.env.VITE_API_ENDPOINT
export const MERCURE_ENDPOINT: string = import.meta.env.VITE_MERCURE_ENDPOINT
export const SENTRY_DSN: string = import.meta.env.VITE_SENTRY_DSN
// Vite leaves the `%VITE_APP_VERSION%` placeholder in index.html when the env var is unset (dev).
const appVersionMeta = document.querySelector<HTMLMetaElement>('meta[name=app-version]')?.content
export const APP_VERSION: string = appVersionMeta && !appVersionMeta.startsWith('%') ? appVersionMeta : 'dev'
export const STATS_ID: string = import.meta.env.VITE_STATS_ID
export const STATS_SCRIPT: string = import.meta.env.VITE_STATS_SCRIPT
